import { render } from "./HelperBot.vue?vue&type=template&id=3636fcc6&scoped=true"
import script from "./HelperBot.vue?vue&type=script&lang=js"
export * from "./HelperBot.vue?vue&type=script&lang=js"

import "./HelperBot.vue?vue&type=style&index=0&id=3636fcc6&lang=css"
import "./HelperBot.vue?vue&type=style&index=1&id=3636fcc6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3636fcc6"]])

export default __exports__